/**
 * Created by mqamhieh on 8/15/16.
 */
(function (app) {

    app.controller('PremiumProfileController', ['$scope', '$state', 'deviceChecker', 'brandDetails',
        function ($scope, $state, deviceChecker, brandDetails) {
            $scope.isShowingYT = false;
            var body = $('body');
            $scope.showPosition = '';
            $scope.brandSlug = brandDetails.slug;
            $scope.searchString = "";

            $scope.hidePopOver = function () {
                body.trigger("click");
            };


            $scope.getCategoryPositions = function() {
                $scope.FOHPositions = [];
                $scope.BOHPositions = [];
                $scope.BOHPositions = [];

                if(brandDetails.brandId){
                    var getEnterpriseActiveCategoryPositions = CareerPortalAPI.getEnterpriseActiveCategoryPositions(brandDetails.brandId)
                        .then(function (res) {
                            res.forEach(function (category) {
                                if(category.code == "FOH"){
                                    $scope.FOHPositions = category.positions;
                                }
                                else if(category.code == "BOH"){
                                    $scope.BOHPositions = category.positions;
                                }
                                else if(category.code == "MANAGE"){
                                    $scope.managementPositions = category.positions;
                                }
                            });
                            $scope.$digest();
                        });
                }
            };

            $scope.showPositionDetails = function (position) {
                $scope.showPosition = $scope.showPosition == position ? '' : position;
                body.animate({
                    scrollTop: $('#' + position).offset().top
                });
            };

            $(".watch-video").fancybox({
                maxWidth	: 800,
                maxHeight	: 600,
                fitToView	: false,
                width		: '100%',
                height		: '70%',
                autoSize	: false,
                closeClick	: false,
                openEffect	: 'none',
                closeEffect	: 'none'
            });

            $scope.initSlider = function() {
                setTimeout(function () {
                    $('.premium-slider-images').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1
                    });
                }, 1);
            };

            $scope.initSlider();

            $scope.$on('tooltip.show', function() {
                var offset = $('.page-body').offset() || {};
                var pageBodyTop = offset.top || 0;

                $(".popover.description-page").css("top", $(document).scrollTop());

                if ($(window).width() <= 640) {
                    body.scrollTop(pageBodyTop);
                }
            });

            var pageName = $state.current.name;
            $scope.innerPage = $state.current.resolve ;
            $scope.innerPage = $scope.innerPage && $state.current.resolve.innder_page ;
            $scope.innerPage = $scope.innerPage && $state.current.resolve.innder_page();

            var facebookPage;
            var twitterPage;

            switch (pageName) {

                case "ned":
                    twitterPage = "thenedlondon";
                    break;

            }

            if (facebookPage) {
                BrandAPI.facebookPageFeeds(facebookPage, 1)
                    .then(function (data) {

                        $scope.facebookPost = data[0] && (data[0].message || data[0].description);
                        $scope.$digest();
                    });
            }

            if (twitterPage) {
                BrandAPI.twitterPageFeeds(twitterPage, 1)
                    .then(function (data) {
                        $scope.twitterPost = data[0] && data[0].text;
                        $scope.$digest();
                    });
            }

            $scope.getCategoryPositions();


            $scope.goToLatestJobs = function(urlPath){
              window.location   = urlPath;
            };

            $scope.toggleTileDetails = function (details, detailsContainer) {
                $scope.showDetails = ($scope.showDetails != details) ? details : '';

                if ($scope.showDetails) {
                    var container = $('#' + detailsContainer);
                    $("html, body").animate({
                        scrollTop: container.offset().top
                    });
                }
            };

            $scope.showTileDetails = function (tile, tileDetails, hasSlider) {
                $timeout(function () {
                    angular.element('.premium-profile-modal').not('.' + tileDetails + ' .premium-profile-modal').click();
                }, 1);

                $('#' + tile).css('opacity','0.5');

                $('.' + tileDetails).slideDown("slow");

                $('html, body').animate({
                    scrollTop: $('.' + tileDetails).offset().top
                }, 500);

                if(hasSlider){
                    if($('.' + tileDetails + ' .slick-slider').length){
                        $('.' + tileDetails + ' .premium-slider-images').slick('slickGoTo', 0);
                    }
                    else{

                        $("." + tileDetails + " .premium-slider-images .slide-text").css("width", "100%");
                        $("." + tileDetails + " .premium-slider-images img").css("width", "100%");
                        $("." + tileDetails + " .premium-slider-images img").css("height", "auto");
                        $('.' + tileDetails + ' .premium-slider-images').slick({
                            slidesToShow: 1,
                            slidesToScroll: 1
                        });

                    }

                }
            };

            $scope.hideTileDetails = function (tile, tileDetails) {
                $('#' + tile).css('opacity','1');
                $('.' + tileDetails).slideUp("slow");
            };

            $scope.searchOpportunitiesHandler = function (e) {
                if($scope.searchString){
                    if((e.type == "keyup" && e.key =="Enter" )|| e.type == "click" ){
                        window.location.href ='/' + $scope.brandSlug + '?filters=jobsPhrase%253D' + $scope.searchString;
                    }
                }
            };

            $scope.handleFaq = function (e) {

                var classes = ['q', 'icon-left-arrow', 'icon-bottom-arrow'];
                var found = false;

                for (var i in classes) {

                    if (e.target.className.indexOf(classes[i]) > -1) {
                        found = true;
                        break;
                    }
                }

                if (found) {
                    if (e.target.parentNode.className.indexOf('active') > -1) {
                        e.target.parentNode.className = e.target.parentNode.className.replace('active', '');
                    } else {
                        e.target.parentNode.className = e.target.parentNode.className + ' active';
                    }
                }
            };

            var self = this;
            self.lastclickedTileTopOffset = 0;

            $("[bs-popover]").click(function(event) {
                if(!deviceChecker.isMobile()){
                    return;
                }
                var clickedTile = $(this);
                var clickedTileOffset = clickedTile.offset();
                self.lastclickedTileTopOffset = clickedTileOffset.top;

                var p = $( ".page-body" );
                var offset = p.offset();
                if (offset) {
                    $("html, body").animate({ scrollTop: offset.top - 20 }, "slow");
                }

                setTimeout(function () {
                    var popover = $('.popover');

                    if (parseInt(popover.css('top')) < -280) {
                        popover.css('top', '-280px');
                    }
                }, 1)
            });
        }
    ]);

})(angular.module('harriApp'));
